<script>
  import { t } from 'svelte-i18n';
  import ModalSection from './modal-section.svelte';
    import Footer from './footer.svelte';
</script>

<ModalSection first="true">
  <div slot="text">
    <h1 class="pb-0 text-fprj-logo">{$t('MODAL.FPRJ.TITLE')}</h1>
    <h1 class="pt-0">{$t('MODAL.FPRJ.TITLE2')}</h1>
  </div>
  <p class="text-opaque-black md2:mb-9" slot="padding">
    {$t('MODAL.FPRJ.DESCRIPTION')}
  </p>
  <img
    class="mr-5 md2:mr-0"
    slot="img"
    alt="fprj screen on a mobile device"
    src="images/fprj-img-1.png"
  />
</ModalSection>

<ModalSection app="fprj" bgDark="true" inverse="true">
  <div slot="text">
    <h1>{$t('MODAL.FPRJ.TITLE3')}</h1>
    <p class="text-opaque-black">
      {@html $t('MODAL.FPRJ.DESCRIPTION2')}
    </p>
  </div>
  <img slot="img" alt="fprj screen on a mobile device" src="images/fprj-img-2.png" />
</ModalSection>

<ModalSection>
  <div slot="text">
    <h1>{$t('MODAL.FPRJ.TITLE4')}</h1>
    <p class="text-opaque-black">
      {$t('MODAL.FPRJ.DESCRIPTION3')}
    </p>
  </div>
  <img
    class="mr-5 md2:mr-0"
    slot="img"
    alt="fprj screen on a mobile device"
    src="images/fprj-img-3.png"
  />
</ModalSection>
<Footer />

<style>
  p {
    @apply py-0;
  }
  img {
    filter: drop-shadow(0px 4px 15px rgba(0, 0, 0, 0.35));
  }
</style>
